require('./data-href.js')

// Translate
$.extend(true, $.magnificPopup.defaults, {
  tClose: 'Zavřít (Esc)', // Alt text on close button
  tLoading: 'Načítám...', // Text that is displayed during loading. Can contain %curr% and %total% keys
  gallery: {
    tPrev: 'Předchozí (Šipka doleva)', // Alt text on left arrow
    tNext: 'Další (Šipka doprava)', // Alt text on right arrow
    tCounter: '%curr% z %total%' // Markup for "1 of 7" counter
  },
  image: {
    tError: '<a href="%url%">Fotku</a> se nepovedlo načíst.' // Error message when image could not be loaded
  },
  ajax: {
    tError: '<a href="%url%">Obsah</a> se nepovedlo načíst.' // Error message when ajax request failed
  }
});

$('a[href*=#]').on('click', function(event){
    event.preventDefault();
    $('html,body').animate({scrollTop:$(this.hash).offset().top}, 500);
});

$('.magnifi-video').magnificPopup({
	type:'iframe'
});

$('.gallery-item a').magnificPopup({
	type:'image',
  mainClass : 'mfp-zoom-in',
	gallery: {
      enabled: true
    }
});

$(".mango-toggle").on("click", function(e){
	e.preventDefault()

	var $this = $(this)
	dClass = $this.data("toggle-class")

	if($this.data("toggle-parent")){
		$this.parent().toggleClass(dClass)
	}else{
		$('body').toggleClass(dClass)
	}

	return false
});
